import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import InlineTable from "../../components/InlineTable";
import {Query} from "react-apollo";
import gql from "graphql-tag";

function evaluateRestrictionType(data) {
  switch(data.get("restrictionType")) {
    case "customer":
      return [data.get("restrictionId"), "customerId"];
    case "account":
      return [data.get("restrictionId"), "accountId"];
    default:
      return [data.get("restrictionId"), "id"];
  }
}

const FIELDS = fromJS([
  { field: "type", title: "Type" },
  { field: "id", title: "Id"},
  { field: "limit", title: "Limit"}
])

const PromoCodePropertiesPanel = (props) => {

  let elements = null;
  if (!props.code) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "code", label: "Id", type: "string"},
      {prop: "type", label: "Type", type: "string"},
      {prop: "restrictionType", label: "Restriction", type: "string"},
      {prop: "restrictionId", label: "Restriction Id", type: "id", fn: evaluateRestrictionType},
      {prop: "percentage", label: "Percentage", type: "number"},
      {prop: "description", label: "Description", type: "text"},
      {prop: "status", label: "Status", type: "string"},
      {prop: "subscriptionsOnly", label: "Only Subscriptions", type: "boolean"},
      {prop: "tagRules", label: "Tag Rules", type: "id"},
      {prop: "limit", label: "Usage Limit", type: "number"},
      {prop: "maxItemsPerUsage", label: "Max Items / Use", type: "number"},
      {prop: "useCount", label: "Usage", type: "number"},
      {prop: "expires", label: "Expires", type: "boolean"},
      {prop: "expiryDate", label: "Expiry Date", type: "string"},
      {prop: "createdAt", label: "Created", type: "string"},
      {prop: "batchClient", label: "Batch Client", type: "string"},
    ])
    let variables = {code: props.code}
    elements = (
      <Query query={GET_PROMO_CODE} variables={variables} skip={!props.code} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let imData = fromJS(data.promoCode);
          let promoCodeItems = imData.get("items").map((item) => {
            if (item.get("limit") === 0) return item.set("limit", "unlimited");
            return item;            
          })
          return (
            <React.Fragment>
              <PropertiesList properties={properties} data={imData} />
              <br/>
              <InlineTable
                key={imData.get("code")}
                itemKey="key"
                data={promoCodeItems}
                fields={FIELDS}
                dataType="promo_code_item"
              />
            </React.Fragment>
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Promo Code" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export const GET_PROMO_CODE = gql`
  query promoCode($code: ID!) {
    promoCode(code: $code) {
      code
      type
      restrictionType
      restrictionId
      percentage
      description
      status
      subscriptionsOnly
      limit
      maxItemsPerUsage
      useCount
      tagRules
      expires
      expiryDate
      items {
        type
        id
        limit
      }
      batchClient
      createdAt
    }
  }
`;

export default PromoCodePropertiesPanel;